<template lang="pug">
.wrapper.wrapper--sidebar
    aside.wrapper--sidebar__sidebar(
        v-if="isAstro !== 'true'"
        v-bind:class="{'is-show': toggleSidebar}"
    )
        //- SidebarResult
        Sidebar(:isKey="isKey" :key="key")
    section.wrapper--sidebar__content
        router-view(:resultGlobalBreadcrumb="breadcrumb")

</template>

<script>
import { mapState } from 'vuex';
// import SidebarResult from './../result/Sidebar.vue';
import Sidebar from '@/components/shell/sidebar/Sidebar.vue';
import { decrypt } from '@/util/crypto';

export default {
    name: 'PageResult',
    components: {
        // SidebarResult,
        Sidebar,
    },
    data: function() {
        return {
            breadcrumb: {
                name: 'Result',
                url: '/result/recent-location',
            },
            isAstro: process.env.VUE_APP_ASTRO,
            toggleSidebar: false,
            from_global_search: false,
        };
    },
    computed: {
        ...mapState([
            // 'load_data_status_profile_subheader',
            // 'load_data_status_single_target_detail',

            'load_data_status_overall_data_location',
            // 'load_data_status_overall_log_recent_location',
            'load_data_status_overall_app_usage',
            'load_data_status_location',
            // 'load_data_status_location_count',
            'load_data_status_browsing',
            // 'load_data_status_browsing_count',
            'load_data_status_device_history',
            'load_data_status_tethered_device',
            'load_data_status_possible_location',
            'load_data_status_aerial_log',
            'load_data_status_signal_status',
            'load_data_status_profile',
            // 'load_data_status_profile_count',
            'load_data_status_get_contact',
            'load_data_status_vehicles',
            'load_data_status_etle',
            'load_data_status_travel_history',
            'load_data_status_tokped',
            'load_data_status_bank_account',
            'load_data_status_personal_identity',
            'load_data_status_travel',
            'load_data_status_pln',
        ]),
        route_name() {
            // return this.$route.matched[0] ? this.$route.matched[0].name : null;
            return this.$route;
        },
        key() {
            return this.$route.params.key;
        },
        isKey() {
            // return this.key!==undefined ? true : false;
            // return (this.key!==undefined && this.key!==null) ? true : false;
            // this.getData();
            return this.key ? true : false;
        },
        // breadcrumb() {
        //     return {
        //         name: 'Result',
        //         url: '/result/'+ (this.isKey ? this.key + '/' : '') +'recent-location',
        //     };
        // },
    },
    watch: {
        // route_name() {
        route_name(newRoute, oldRoute) {
            // console.log('route change');
            // if (newRoute.matched[0].name === 'PageResult' && newRoute.matched[0].name !== oldRoute.matched[0].name)
            //     this.getData();

            if (newRoute.matched[0].name === 'PageResult' && oldRoute.matched[0].name === 'PageResult') {
                if(newRoute.matched[1].name != oldRoute.matched[1].name) {
                    this.getDataOnRouteChange(newRoute, oldRoute);
                }
            }
        },
        // key() {},
        async key() {
        /* eslint-disable no-unused-vars */
        // key(newKey, oldKey) {
            // console.log('==================== watch key on Result.vue')
            // console.log('{newKey, oldKey}')
            // console.log({newKey, oldKey})

            // console.log('watch key()')
            // console.log([newKey, oldKey])

            // add after trigger api on click menu
            if (this.route_name.matched[0].name === 'PageResult') {
                await this.$store.dispatch('setEmptyResultData', []);
                this.getData();
            }
        },
        isKey() {
            // this.getData();
        },
        /* eslint-disable no-unused-vars */
        // isKey(newKey, oldKey) {
        //     console.log('==================== watch isKey on Result.vue')
        //     // if (this.route_name === 'PageResult') {
        //     if (newKey) {
        //         this.getData();
        //     } else {
        //         this.$store.dispatch('setEmptyResultData');
                
        //         // empty vehicle (temporary)
        //         this.$store.commit('setVehicles', []);
        //     }
        // },
        breadcrumb() {},
    },
    methods: {
        getDataOnRouteChange(newRoute, oldRoute) {
            // console.log(this.from_global_search);
            // console.log('newRoute.matched[1].name');
            // console.log(newRoute.matched[1].name);
            // console.log('from_global_search');
            // console.log(this.from_global_search);
            // console.log('this.load_data_status_overall_app_usage.status');
            // console.log(this.load_data_status_overall_app_usage.status);
            // console.log('this.load_data_status_bank_account');
            // console.log(this.load_data_status_bank_account);
            // console.log('this.load_data_status_aerial_log');
            // console.log(this.load_data_status_aerial_log);
            // console.log(this.load_data_status_aerial_log.status);
            if (this.from_global_search === false) {
                if (
                    (newRoute.matched[1].name === 'result-recent-location' && this.load_data_status_overall_data_location.status === false) ||
                    (newRoute.matched[1].name === 'result-application-usage' && this.load_data_status_overall_app_usage.status === false) ||
                    (newRoute.matched[1].name === 'result-history-location' && this.load_data_status_location.status === false) ||
                    (newRoute.matched[1].name === 'result-history-browsing' && this.load_data_status_browsing.status === false) ||
                    (newRoute.matched[1].name === 'result-device-history' && this.load_data_status_device_history.status === false) ||
                    (newRoute.matched[1].name === 'result-tethered-devices' && this.load_data_status_tethered_device.status === false) ||
                    (newRoute.matched[1].name === 'result-possible-location' && this.load_data_status_possible_location.status === false) ||
                    (newRoute.matched[1].name === 'result-aerial-log' && this.load_data_status_aerial_log.status === false) ||
                    (newRoute.matched[1].name === 'result-signal-status' && this.load_data_status_signal_status.status === false) ||
                    (newRoute.matched[1].name === 'result-profile' && this.load_data_status_profile.status === false) ||
                    (newRoute.matched[1].name === 'result-prediction-nickname' && this.load_data_status_get_contact.status === false) ||
                    (newRoute.matched[1].name === 'result-vehicles' && this.load_data_status_vehicles.status === false) ||
                    (newRoute.matched[1].name === 'result-etilang' && this.load_data_status_etle.status === false) ||
                    (newRoute.matched[1].name === 'result-marketplace' && this.load_data_status_tokped.status === false) ||
                    (newRoute.matched[1].name === 'result-travel-history' && this.load_data_status_travel_history.status === false) ||
                    (newRoute.matched[1].name === 'result-bank-account' && this.load_data_status_bank_account.status === false) ||
                    (newRoute.matched[1].name === 'result-travel' && this.load_data_status_travel.status === false) ||
                    (newRoute.matched[1].name === 'result-pln' && this.load_data_status_pln.status === false) ||
                    (newRoute.matched[1].name === 'result-personal-identity' && this.load_data_status_personal_identity.status === false)
                )
                    // console.log('masuk getdata');
                    this.getData(true);
            } else {
                this.from_global_search = false;
            }
        },
        async getData(from_sidebar=false, set_emtpy=false) {
            if (set_emtpy === true)
                await this.$store.dispatch('setEmptyResultData', []);

            // if (this.isKey) {
            //     if (this.route_name === 'PageResult') {
            //         // let decrypt_data = decrypt(this.$route.params.key);
            //         let decrypt_data = decrypt(this.key);
            //         decrypt_data = decrypt_data.split('&&');

            //         // console.log('on Result.vue getData()');
            //         // console.log(decrypt_data);

            //         var key = decrypt_data[0];
            //         var type = decrypt_data[1];

            //         // empty vehicle (temporary) -> old, with jasaraharja api
            //         // this.$store.commit('setVehicles', []);

            //         // if (type === 'nopol') {
            //         //     // empty overall data (temporary)
            //         //     this.$store.dispatch('setEmptyResultData');
                        
            //         //     // this.$store.commit('setVehicles', []);
            //         //     this.$store.dispatch('getVehicles', [key]);
            //         // } else {
            //         //     // // empty vehicle (temporary)
            //         //     // this.$store.commit('setVehicles', []);
            //         //     this.$store.commit('setLoadDataStatusVehicles', false);
                        
            //         //     this.$store.dispatch('getResultData', [key, type]);
            //         // }

            //         // new vehicle api with bff master
            //         this.$store.dispatch('getResultData', [key, type]);

            //     }
            // } else {
            //     if (this.route_name === 'PageResult')
            //         this.$store.dispatch('setEmptyResultData');

            //     // empty vehicle (temporary) -> old, with jasaraharja api
            //     // this.$store.commit('setVehicles', []);
            //     // this.$store.commit('setLoadDataStatusVehicles', false);
            // }

            if (this.route_name.matched[0] && this.route_name.matched[0].name === 'PageResult' ) {

                // console.log([this.route_name.matched[0].name, this.isKey])
                // console.log('result . vue getData()')
                // console.log(this.route_name.matched[1].name)
                // console.log(from_sidebar)

                if (this.isKey) {

                    let decrypt_data = decrypt(this.key);
                    decrypt_data = decrypt_data.split('&&');

                    var key = decrypt_data[0];
                    var type = decrypt_data[1];

                    // console.log([key, type])
                    // console.log(type)

                    // 'result-recent-location' ||
                    // 'result-profile' || 
                    // 'result-marketplace' || 

                    let route = 'all';

                    if (from_sidebar === false) {
                        this.from_global_search = false
                        if (type === 'msisdn' || type === 'imsi' || type === 'imei-sv') {
                            route = 'result-recent-location';
                        } else if (type === 'nik') {
                            route = 'result-profile';
                        } else if (type === 'nopol') {
                            route = 'result-vehicles';
                        } else if (type === 'email') {
                            // route = 'result-marketplace';
                            route = 'result-personal-identity';
                        }
                    } else {
                        route = this.route_name.matched[1].name;
                    }
                    // console.log('getResultData route:' + route)
                    // console.log('getResultData key:' + key)
                    // console.log('getResultData type:' + type)
                    // console.log('result method filter')
                    this.$store.dispatch('getResultData', [key, type, route, from_sidebar])
                    .then((resp) => {
                        // console.log(resp)
                        if (resp === 'not_allowed') {
                            this.$swal.fire({
                                icon: 'error',
                                // title: 'You have reached limit for search MSISDN '+ key +'!',
                                title: 'The limit has reached for search MSISDN '+ key +'!',
                                // text: 'You only can search this number 10 times a day',
                                // confirmButtonText: 'Yes!',
                                confirmButtonText: 'Ok',
                                // confirmButtonColor: '#DD6B55',
                                showCancelButton: false,
                                allowOutsideClick: false,
                            })
                            .then(() => {
                                this.$router.push({ name: 'PageDashboard' });
                            });
                        }
                    });

                } else {
                    // console.log('else setEmptyResultData')
                    this.$store.dispatch('setEmptyResultData', []);
                }                
            }
        },
        

        clickPopupShow: function() {
            // console.log('heho')
        }
    },
    async mounted() {
        // console.log('=============== in Result.vue');
        // let a = encrypt('6281370066649');
        // console.log(a);
        // console.log(this.$route.matched[0].name)
        EventEmit.$on('toggleSidebar', () => {
            this.toggleSidebar = !this.toggleSidebar
        });
        // EventEmit.$on('fromGlobalSearch', () => {
        //     this.from_global_search = true;
        //     // console.log('run in fromGlobalSearch')
        // });

        // add after trigger api on click menu -> old
        // if (this.from_global_search === false)
        //     await this.$store.dispatch('setEmptyResultData', []);
        //     this.getData(true);
    },
    beforeRouteEnter(to, from, next) {
        next(vm => { 
            if ((from.matched[0] && from.matched[0].name !== 'PageResult') && to.matched[0].name === 'PageResult') {
                vm.from_global_search = true;
                vm.getData(false, true);
            } else {
                vm.getData(true, true);
            }
            next();
        });
    },
}
</script>

